var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-12 pt-8"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }